import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const StyledDateBox = styled(Box)(({ isToday, theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    minWidth: '2.625rem',
    height: '2.688rem',
    margin: '8px',
    marginLeft: '0px',
    borderRadius: '8px',
    backgroundColor: isToday ? theme.palette.background.secondarySelected : 'transparent',
  };
});

export const StyledDateText = styled(Typography)(({ isPastDate, theme }) => ({
  color: isPastDate ? theme.colors.gray : 'inherit',
}));
